export class Sessions {
    public summary: number;
}
